import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import settings from '../../config/settings';
import store from '../store';

interface SettingsArg {
    category: string;
    projectId?: string | null;
}

interface SaveSettingsArg extends SettingsArg {
    data: any;
}

const buildPath = ({category, projectId}: SettingsArg) =>
    projectId
        ? `/projects/${projectId}/settings/${category}`
        : `/settings/${category}`;

export const settingsApi = createApi({
    reducerPath: 'settingsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: settings.drillholeApiUrl,
        prepareHeaders: (headers) => {
            const state = store.getState();
            const token = state.keycloakData?.keycloak?.keycloakToken;
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ['Settings'],
    endpoints: (builder) => ({
        getSettings: builder.query<any, SettingsArg>({
            query: (arg) => buildPath(arg),
            providesTags: (_result, _error, {category, projectId}) => [
                {type: 'Settings', id: `${projectId ?? 'global'}::${category}`},
            ],
        }),
        saveSettings: builder.mutation<any, SaveSettingsArg>({
            query: ({data, ...arg}) => ({
                url: buildPath(arg),
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (_result, _error, {category, projectId}) => [
                {type: 'Settings', id: `${projectId ?? 'global'}::${category}`},
            ],
        }),
    }),
});

export const {
    useGetSettingsQuery,
    useSaveSettingsMutation,
} = settingsApi;
